import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-154c3c0b")

_pushScopeId("data-v-154c3c0b")
const _hoisted_1 = { class: "text-grey-3 px-20" }
const _hoisted_2 = { class: "title font-size-30 pb-3 mb-10" }
const _hoisted_3 = { class: "draggable-modal" }
const _hoisted_4 = { class: "list-setting flex justify-between mx-20" }
const _hoisted_5 = { class: "item-setting" }
const _hoisted_6 = { class: "title-item-setting font-bold text-center mb-1 p-2" }
const _hoisted_7 = { class: "item-setting" }
const _hoisted_8 = { class: "title-item-setting font-bold text-center mb-1 p-2" }
const _hoisted_9 = { class: "flex justify-center m-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_draggable = _resolveComponent("draggable")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShow = $event)),
    width: "1086px",
    noScrollBody: ""
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('selectDisplayItems')), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('displayItemList')), 1),
              _createVNode(_component_draggable, {
                class: "list-group",
                list: _ctx.listDefine,
                onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragging = true)),
                onEnd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragging = false)),
                disabled: !_ctx.enabled,
                "item-key": "data_master_name",
                "ghost-class": "ghost",
                group: "people"
              }, {
                item: _withId(({ element }) => [
                  (_openBlock(), _createBlock("div", {
                    class: ["list-group-item text-center p-1 mb-1", { 'not-draggable': !_ctx.enabled }],
                    key: element.id
                  }, _toDisplayString(element.data_master_name), 3))
                ]),
                _: 1
              }, 8, ["list", "disabled"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t('columnName')), 1),
              _createVNode(_component_draggable, {
                class: "list-group",
                list: _ctx.listSelected,
                onStart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragging = true)),
                onEnd: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragging = false)),
                disabled: !_ctx.enabled,
                "item-key": "data_master_name",
                "ghost-class": "ghost",
                group: "people"
              }, {
                item: _withId(({ element }) => [
                  (_openBlock(), _createBlock("div", {
                    class: ["list-group-item text-center p-1 mb-1", { 'not-draggable': !_ctx.enabled }],
                    key: element.id
                  }, _toDisplayString(element.data_master_name), 3))
                ]),
                _: 1
              }, 8, ["list", "disabled"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            onClick: _ctx.postSettingViewTimeCard,
            class: "btn-light-blue h-10 w-20 mb-2 w-50 mr-5"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            onClick: _ctx.handleCancel,
            class: "btn-gradation-secondary h-10 w-20 mb-2 w-50"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('buttonCancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})